import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import StafetActions from '../StafetActions/StafetActions.vue'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import { computed, onBeforeMount, ref } from 'vue'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import fieldsConfig from './config/fieldsConfig'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagSomFighterStepTwo',
    components: {
        StafetActions,
        FormInputDropdown,
        FormCheckbox
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const tshirtSize = ref('')
        const participateInFreeLunch = ref(false)

        const tshirtSizes = computed(() => {
            const array = []
            props.tshirtSizes.forEach((size) => {
                array.push({
                    name: size.displayName,
                    value: size.value
                })
            })
            return array
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_AS_FIGHTER
            )

            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'tshirtSize',
                        value: getFieldValue(storedFields, 'tshirtSize')
                    },
                    {
                        name: 'participateInFreeLunch',
                        value: getFieldValue(
                            storedFields,
                            'participateInFreeLunch'
                        )
                    }
                ])
            }
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value =
                    field.value
                switch (field.name) {
                    case 'tshirtSize':
                        tshirtSize.value = field.value
                        return
                    case 'participateInFreeLunch':
                        participateInFreeLunch.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const setTshirtSize = (value) => {
            tshirtSize.value = value
            validateField('tshirtSize', value)
        }

        const setParticipateInFreeLunch = (value) => {
            participateInFreeLunch.value = value
            validateField('participateInFreeLunch', value)
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const showTshirtSizeErrorMessage = computed(() => {
            return (
                !nonEmptyStringValidator(tshirtSize.value) &&
                props.displayInputError
            )
        })

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            tshirtSize,
            tshirtSizes,
            participateInFreeLunch,
            stepModel,
            validateField,
            setParticipateInFreeLunch,
            setTshirtSize,
            showTshirtSizeErrorMessage
        }
    }
}
